import { render } from "./ClientComprasRegistrar.vue?vue&type=template&id=231ca57e&scoped=true"
import script from "./ClientComprasRegistrar.vue?vue&type=script&lang=js"
export * from "./ClientComprasRegistrar.vue?vue&type=script&lang=js"

import "./ClientComprasRegistrar.vue?vue&type=style&index=0&id=231ca57e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231ca57e"]])

export default __exports__